// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"b2a8d041","356":"801b61c0","504":"bf15ca25","694":"1f162b8a","727":"00d756a0","888":"203c9854"}[chunkId] + ".chunk.css";
};